<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Cotação Fornecedor</div>
</div>
<div>
  <mat-tab-group (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Cotação Fornecedor">
      <div class="mt-4">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <form-search-quote-tg
                [search]="inputSearch"
                (responseSearch)="search($event)"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="mt-6">
          @if (!loading) {
            <div>
              <table-list-purchases-quote-supplier-page
                [spinLoad]="spinLoad"
                [dataSource]="itemsList"
                [columns]="columns"
                (viewItem)="viewItem($event)"
              />
              @if (itemsList.length > 0) {
                <mat-paginator
                  [length]="numberRows"
                  [pageSize]="rows"
                  [pageIndex]="page - 1"
                  [pageSizeOptions]="[5, 10, 20, 30]"
                  (page)="onPageEvent($event)"
                >
                </mat-paginator>
              }
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Solicitação de Desconto">
      <div class="mt-6">
        @if (!discountLoading) {
          <div>
            <table-list-purchases-quote-supplier-page
              [spinLoad]="spinLoad"
              [dataSource]="discountList"
              [columns]="discountColumns"
              (applyDiscount)="applyDiscountItem($event)"
            />
            @if (discountList.length > 0) {
              <mat-paginator
                [length]="discountNumberRows"
                [pageSize]="discountRows"
                [pageIndex]="discountPage - 1"
                [pageSizeOptions]="[5, 10, 20, 30]"
                (page)="onDiscountPageEvent($event)"
              >
              </mat-paginator>
            }
          </div>
        } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
